import { createContext, useContext } from 'react';
import { SnackbarContextType } from './types';

export const SnackbarContext = createContext<SnackbarContextType | undefined>(
  undefined
);

export const useSnackbar = (): SnackbarContextType => {
  const context = useContext(SnackbarContext);

  if (!context) {
    // Return no-op functions when provider is not available
    return {
      snackbar: null,
      showSnackbar: (): void => {
        // No-op when provider is not available
      },
      dismissSnackbar: (): void => {
        // No-op when provider is not available
      }
    };
  }

  return context;
};

export default SnackbarContext;
